import { FieldValues } from "react-hook-form";

import { DomesticPriceAddress } from "./schemas";

export interface CalculatorForm extends FieldValues {
  Departure: DomesticPriceAddress | null;
  Arrival: DomesticPriceAddress | null;
  Weight: number | null;
  Volume: number | null;
  IsDangerous: boolean;
  IsFragile: boolean;
  IsTemperatureControlled: boolean;
  UseCompany: boolean;
}

export const defaultCalculatorFormValues: CalculatorForm = {
  Departure: null,
  Arrival: null,
  Weight: null,
  Volume: null,
  IsDangerous: false,
  IsFragile: false,
  IsTemperatureControlled: false,
  UseCompany: false,
};
